document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', (event) => {
      const option = event.target.selectedOptions[0];
      const form = event.target.closest('form');
      const productInfo = event.target.closest('.product-info');
      if (!form || !option) return;
      const idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = option.value;
      const priceTarget = productInfo ? productInfo.querySelector('[data-product-price]') : null;
      if (priceTarget && option.dataset.price) priceTarget.textContent = option.dataset.price;
    });
  });

  document.querySelectorAll('[data-gallery-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const shell = button.closest('.product-media-shell');
      if (!shell) return;
      const drawer = shell.querySelector('.product-gallery-drawer');
      const toggles = shell.querySelectorAll('[data-gallery-toggle]');
      if (!drawer) return;
      const isOpen = !drawer.hasAttribute('hidden');
      if (isOpen) drawer.setAttribute('hidden', 'hidden');
      else drawer.removeAttribute('hidden');
      toggles.forEach((toggleBtn) => toggleBtn.setAttribute('aria-expanded', String(!isOpen)));
    });
  });

  document.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const shell = thumb.closest('.product-media-shell');
      if (!shell) return;
      const mainImage = shell.querySelector('[data-product-main-image]');
      if (mainImage && thumb.dataset.fullImage) {
        mainImage.src = thumb.dataset.fullImage;
        mainImage.srcset = '';
        if (thumb.dataset.alt) mainImage.alt = thumb.dataset.alt;
      }
      shell.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });
});
